import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalDescription } from "@air/primitive-modal";
import { useCallback } from "react";
import { RegenerateShareLinkButtons } from "~/components/SharePrivateContentModal/RegenerateLink/RegenerateShareLinkButtons";
import { ShareModalHeader } from "~/components/SharePrivateContentModal/ShareModalHeader";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { useRegenerateShortIdForClip } from "~/swr-hooks/shortUrl/useRegenerateShortIdForClip";
export const SharePrivateClipRegenerate = (param)=>{
    let { clip, trackLocation, shortIdInfo, onClose, onCancel, onRegenerated, boardContext } = param;
    const { currentWorkspace } = useCurrentWorkspace();
    const { regenerateShortIdForClip } = useRegenerateShortIdForClip();
    const onRegenerate = useCallback(()=>{
        const workspaceId = currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id;
        if (!workspaceId) {
            throw new Error("No workspace id");
        }
        regenerateShortIdForClip.mutate({
            workspaceId,
            clipId: clip.id,
            shortId: shortIdInfo.id,
            permissions: shortIdInfo.permissions,
            boardContext,
            trackLocation
        }, {
            onSuccess: ()=>{
                onClose();
                onRegenerated();
            }
        });
    }, [
        currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id,
        boardContext,
        clip.id,
        onClose,
        onRegenerated,
        regenerateShortIdForClip,
        shortIdInfo.id,
        shortIdInfo.permissions,
        trackLocation
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: true,
        onDismiss: onClose,
        children: [
            /*#__PURE__*/ _jsx(ShareModalHeader, {
                onClose: onClose,
                title: "Generate new link?"
            }),
            /*#__PURE__*/ _jsx(ModalDescription, {
                children: "This will break the current URL and people with the old link will no longer have access to the asset. Are you sure you want to generate a new URL?"
            }),
            /*#__PURE__*/ _jsx(RegenerateShareLinkButtons, {
                isLoading: regenerateShortIdForClip.isPending,
                onRegenerate: onRegenerate,
                onClose: ()=>{
                    onClose();
                    onCancel();
                }
            })
        ]
    });
};
